import StepConnector from '@mui/material/StepConnector';
import { FC } from 'react';
import { YodaColors } from 'yoda-ui/yodaTheme';

const stepConnectorVerticalStyle = {
  margin: '-10px 0',
  '& .MuiStepConnector-line': {
    minHeight: '6rem',
    borderLeft: `2px solid ${YodaColors.neutralGrey5}`,
    marginLeft: '11.5px',
  },
};

const stepConnectorHorizontalStyle = {
  width: 'auto',
  height: 0,
  margin: 0,
  border: `${YodaColors.gray4} solid 1px`,
};

type StepperConnectorProps = {
  orientation?: 'vertical' | 'horizontal';
};

const StyledStepConnector: FC<StepperConnectorProps> = ({ orientation = 'vertical' }) => (
  <StepConnector sx={ orientation === 'vertical' ? stepConnectorVerticalStyle : stepConnectorHorizontalStyle } />
);

export default StyledStepConnector;
